var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"dimmer",on:{"click":function($event){return _vm.on_dimmer_close()}}}),_vm._v(" "),_c('div',{staticClass:"popup",class:_vm.popup_cls},[_vm._t("default"),_vm._v(" "),(_vm.btnClose)?_c('div',{staticClass:"modal-closer",on:{"click":function($event){return _vm.on_btn_close()}}},[_vm._v("X")]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41009526","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = null
// module chunks = 